import React, { useState, useEffect } from 'react'
import Banner from '../Banner/index'
// import HotCollection from '../HotCollection/index'
// import TVSupport from '../TvSupport/index'
// import SearchNFT from '../SearchNFTS/index'
import { hotCollection } from '../HotCollection/api'
// import MarketPlace from '../marketplace/marketplace'
import { Assets } from '../../web3config/metadata'
import Auction from '../../utils/contractHandler/auctions'
import { LoaderPending } from '../loadingPending'
import { useSelector, useDispatch } from 'react-redux'
import { setHotCollectiondata } from '../marketplace/marketplaceReducer'
// import Networks from '../networks'

const HotCollection1 = React.lazy(() => import('../HotCollection/index'))
const TvSupport1 = React.lazy(() => import('../TvSupport/index'))
const Networks1 = React.lazy(() => import('../networks'))
const SearchNFT1 = React.lazy(() => import('../SearchNFTS/index'))
const MarketPlace1 = React.lazy(() => import('../marketplace/marketplace'))

function Home () {
  const dispatch = useDispatch()
  const [searchResult, setSearchResult] = useState(false)
  const hotcollectiondata = useSelector(
    state => state.marketplace.hotcollection
  )
  const [hotCollectiondata, setHotCollection] = useState([])
  const [loading, setLoading] = useState(true)
  const currentNetwork = localStorage?.getItem('currentNetwork') || 'MUMBAI'

  const Provider = {
    type: String,
    chain: 'polygon',
    provider: Object,
    ERC20: [],
    explorer: String,
    sockets: String,
    web3Mod: Object
  }

  useEffect(() => {
    window.scrollTo(0, 0)
    if (
      currentNetwork == 'EHETERUM' &&
      process.env.REACT_APP_ENVIRONMENT == 'live'
    ) {
      setLoading(false)
      setHotCollection([])
      return
    }
    console.log(hotCollectiondata)
    if (hotcollectiondata?.length > 0) {
      setLoading(false)
      setHotCollection(hotcollectiondata)
      return
    }
    setLoading(true)
    hotCollection?.getHotCollection(async (err, data) => {
      console.log(err)
      console.log(data)
      if (data?.data?.data == undefined) {
        setLoading(false)
        setHotCollection([])
      } else {
        const onions = Assets[Provider.chain].ONION
        onions.forEach(async onion => {
          const auctions = await Auction.onionAuctions(
            onion,
            Assets[Provider.chain].ERC20
          )
          console.log(auctions)
          var filterCollection = data?.data?.data?.map(item => {
            const filterdata = auctions?.find(
              element => element?.tokenId == item?.tokenId
            )
            console.log(filterdata)
            if (filterdata != null && filterdata != undefined) {
              return { ...filterdata, ...item }
            } else {
              return item
            }
          })

          console.log(filterCollection)
          filterCollection = filterCollection.map(item => {
            if (
              item?.properties?.isMinted == 1 &&
              item?.properties?.isAuctioned == 1 &&
              item?.properties?.marketplaceAdded == 1
            ) {
              return { ...item, commingSoon: false }
            }
            // else if (item?.properties?.isMinted == 0 && item?.properties?.isAuctioned == 0 && item?.properties?.marketplaceAdded == 0) {
            //     return { ...item, commingSoon: true }
            // }
            else if (
              item?.properties?.isMinted == 1 &&
              item?.properties?.isAuctioned == 0 &&
              item?.properties?.marketplaceAdded == 1
            ) {
              return { ...item, commingSoon: true }
            } else if (
              item?.properties?.isMinted == 1 &&
              item?.properties?.isAuctioned == 0 &&
              item?.properties?.marketplaceAdded == 1
            ) {
              return { ...item, commingSoon: true }
            } else if (
              item?.properties?.isMinted == 0 &&
              item?.properties?.isAuctioned == 1 &&
              item?.properties?.marketplaceAdded == 1
            ) {
              return { ...item, commingSoon: true }
            } else if (
              item?.properties?.isMinted == 0 &&
              item?.properties?.isAuctioned == 0 &&
              item?.properties?.marketplaceAdded == 1
            ) {
              return { ...item, commingSoon: true }
            }
          })

          filterCollection = filterCollection.map(item => {
            if (item?.commingSoon == true) {
              return item
            } else {
              if (
                item?.commingSoon == false &&
                item?.hasOwnProperty('pricePerCard')
              ) {
                return item
              }
            }
          })
          console.log(filterCollection)
          filterCollection = filterCollection?.filter(item => item != undefined)
          console.log(filterCollection)
          setHotCollection(filterCollection)
          dispatch(setHotCollectiondata(filterCollection))
          setLoading(false)
        })
      }
    })
  }, [])
  return (
    <>
      {searchResult == true ? (
        <React.Suspense fallback={<p>Loading</p>}>
          <SearchNFT1 />
        </React.Suspense>
      ) : (
        <>
          <Banner />
          {
            <section class='collection-explore' style={{ overflow: 'hidden' }}>
              <div class='overlay pb-5'>
                {/* //py-5 */}
                <React.Suspense fallback={<LoaderPending />}>
                  <Networks1 />
                </React.Suspense>
                <React.Suspense fallback={<LoaderPending />}>
                  {loading == true ? (
                    <div class='loading-spinner'>
                      <img
                        src={`${process.env.REACT_APP_IMAGE_URL}/assets/images/exs-loader.svg`}
                        alt='loader-logo'
                      />
                    </div>
                  ) : hotCollectiondata?.length > 0 ? (
                    <HotCollection1 hotCollectiondata={hotCollectiondata} />
                  ) : null}
                </React.Suspense>
                <React.Suspense fallback={<LoaderPending />}>
                  <MarketPlace1 home={true} lower={0} higher={8} />
                </React.Suspense>
                <React.Suspense fallback={<LoaderPending />}>
                  <TvSupport1 />
                </React.Suspense>
              </div>
            </section>
          }
        </>
      )}
    </>
  )
}

export default Home
